import { Link, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';

const ContentHeader = ({ title }) => {
    const navigate = useNavigate();

    return (
        <nav aria-label="breadcrumb" className="modern-breadcrumb">
            <ol className="breadcrumb">
                <li className="breadcrumb-item"><Link to="/"> <i className="bi bi-speedometer2 me-1"></i> Inicio</Link></li>
                <li className="breadcrumb-item active" aria-current="page">{title}</li>
            </ol>
            <button onClick={() => navigate(-1)} className="btn-back">
                <FontAwesomeIcon icon={faChevronLeft} /> Atrás
            </button>
        </nav>
    );
}

export default ContentHeader;
